import React from 'react';
import classNames from 'classnames';

interface AlertProps {
  type: 'success' | 'danger' | 'info';
  canClose?: boolean;
  className?: string;
  style?: any;
  children?: any;
}

const Alert = ({ type, canClose, className, style, children }: AlertProps) => {
  return (
    <div className={classNames([`alert alert-bordered alert-${type}`, className])} role="alert" style={style}>
      {canClose !== false && (
        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      )}
      {children}
    </div>
  );
};

export default Alert;
